import * as React from 'react';
import onClickOutside, { OnClickOutProps } from 'react-onclickoutside';

interface Props {
	isOpen: boolean;
	keepMounted?: boolean;
	onClose: (event: React.MouseEvent) => void;
}

class Dropdown extends React.Component<OnClickOutProps<Props>> {
	public static defaultProps: Partial<Props> = {
		keepMounted: false
	};

	public handleClickOutside(e: React.MouseEvent): void {
		if ((e as any).offsetX <= document.body.clientWidth) {
			this.props.onClose(e);
		}
	}

	public render(): React.ReactNode {
		// Do not remove dropdown content from the DOM.
		// Necessary in case of nested dropdowns (autocomplete dropdown + directions popup);
		if (this.props.keepMounted) {
			const styles: React.CSSProperties = {};

			if (!this.props.isOpen) {
				styles.display = 'none';
			}

			return <div style={styles}>{this.props.children}</div>;
		}

		return this.props.isOpen ? this.props.children : null;
	}
}

export default onClickOutside<any>(Dropdown) as any;
